import React from 'react';
import { Target, Eye, Award, Shield } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const About = () => {
  const values = [
    {
      icon: Target,
      title: 'Our Mission',
      description:
        'We engineer and deliver high‑performance energy infrastructure with precision, innovation, and uncompromising safety. Through advanced engineering practices, disciplined execution, and deep technical expertise, we provide reliable, efficient, and sustainable solutions for the oil and gas industry.'
    },
    {
      icon: Eye,
      title: 'Our Vision',
      description:
        'To be a trusted leader in the oil and gas industry—driving sustainable growth, enabling energy security, and shaping a future where responsible resource development supports economic and environmental progress.'
    },
    {
      icon: Award,
      title: 'Excellence',
      description:
        'We maintain the highest standards in every project, ensuring quality, safety, and environmental responsibility in all our operations.'
    },
    {
      icon: Shield,
      title: 'Integrity',
      description:
        'Built on a foundation of trust and transparency, we deliver on our promises and maintain strong relationships with all stakeholders.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            About <span className="text-red-600">Total Vision</span>
          </h2>
          <div className="w-24 h-1 bg-red-600 mx-auto mb-6" />
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            With a wealth of experience, we've built firm foundations for Project Management Solutions
          </p>
        </div>

        {/* Main Content */}
        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-slate-900">Who We Are</h3>
            <p className="text-slate-600 leading-relaxed">
              Total Vision Oil and Gas Fields Services and Consultancy LLC is a leading engineering and project
              management company based in Abu Dhabi, UAE. We specialize in providing comprehensive solutions
              for the oil and gas industry across the Middle East and beyond.
            </p>
            <p className="text-slate-600 leading-relaxed">
              Our team of highly skilled professionals brings decades of combined experience in engineering,
              construction, quality management, and project execution. We've successfully delivered numerous
              complex projects, establishing ourselves as a trusted partner for major oil and gas operators.
            </p>
            <div className="flex items-center gap-4 pt-4">
              <div className="flex-1 h-1 bg-gradient-to-r from-blue-600 to-transparent" />
            </div>
          </div>
          <div className="relative">
            <img
              src="https://customer-assets.emergentagent.com/job_precision-vision/artifacts/zzto4vh3_engineers-reviewing-blueprints-construction-site.jpg"
              alt="Engineering Team"
              className="rounded-2xl shadow-2xl w-full h-full object-cover"
            />
            <div className="absolute -bottom-6 -left-6 w-48 h-48 bg-blue-600/10 rounded-2xl -z-10" />
          </div>
        </div>

        {/* Values Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((value, index) => (
            <Card
              key={index}
              className="border-none shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 bg-white"
            >
              <CardContent className="p-6">
                <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-700 rounded-xl flex items-center justify-center mb-4">
                  <value.icon className="w-7 h-7 text-white" />
                </div>
                <h4 className="text-xl font-bold text-slate-900 mb-3">{value.title}</h4>
                <p className="text-slate-600 text-sm leading-relaxed">{value.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Quote Section */}
        <div className="mt-16 bg-gradient-to-r from-indigo-800 to-indigo-900 rounded-2xl p-8 md:p-12 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <div className="text-6xl mb-4 opacity-50">“</div>
            <p className="text-2xl md:text-3xl font-light italic mb-6">
              A successful person is one who can lay a firm foundation with the bricks others have thrown at them.
            </p>
            <p className="text-lg font-semibold">- David Brinkley</p>
            <p className="mt-6 text-blue-100">
              We have a wealth of experience hence the foundations are now ready for us to build your firm foundation.
              We caught all the bricks!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;